import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';
 
function User() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState([]);
    useEffect(() => {
        document.title = 'Infomart | Agent User';
        setIsLoading(true);
        axios.get(`${BASE_URL}/agent/user`, {  
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setUser(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []); 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className="card">
                            <div className="card-header fw-bold" style={{ whiteSpace: "nowrap" }}>User</div>
                            <div className="table-responsive">
                                <table className="table table-bordered" style={{ minWidth: "600px", width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">User</th> 
                                            <th scope="col">Email ID</th>  
                                            <th scope="col">Address</th>  
                                            <th scope="col">Register Date</th>
                                        </tr> 
                                    </thead>
                                    <tbody className="align-middle">
                                        {user && user.length > 0 ? (
                                            user.map((data, i) => ( 
                                                <tr key={i}> 
                                                    <th scope="row">{i + 1}</th>
                                                    <td>
                                                        <b>{data.name}</b>
                                                        <br />
                                                        +91 {data.phone}
                                                    </td> 
                                                    <td>{data.email}</td> 
                                                    <td>{data.house_no}, {data.road_name}, {data.district}, {data.state}</td>  
                                                    <td>{format(data.created_at, 'dd MMM, yyyy')}</td>
                                                </tr> 
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="5" className="text-center">No data available.</th>
                                            </tr>
                                        )}
                                    </tbody>
                                 </table> 
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default User; 